export default __webpack_public_path__ + "static/galvanic1-5279fbd374e887bb2b469e37161a7f68.jpg";